import { Node, mergeAttributes } from '@tiptap/core';
import { NodeSelection } from 'prosemirror-state';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    spinner: {
      selectLastSpinner: () => ReturnType;
    };
  }
}

export const Spinner = Node.create({
  name: 'spinner',

  group: 'inline',
  inline: true,
  atom: true,

  addCommands() {
    return {
      selectLastSpinner:
        () =>
        ({ state, dispatch }) => {
          if (dispatch) {
            const { doc, tr } = state;
            let lastSpinnerPos: number | undefined = undefined;

            // Find the last spinner
            doc.descendants((node, pos) => {
              if (node.type.name === 'spinner') {
                lastSpinnerPos = pos;
              }
            });

            if (lastSpinnerPos !== undefined) {
              const transaction = tr.setSelection(
                NodeSelection.create(tr.doc, lastSpinnerPos)
              );
              dispatch(transaction);
              return true;
            }
          }

          return false;
        },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'img',
      mergeAttributes(HTMLAttributes, {
        alt: 'spinner',
        class: 'spinner',
        src: 'https://st.deviantart.net/loading/llama-med.gif',
        'data-spinner': 1,
      }),
    ];
  },
});

export default Spinner;
